import { useCallback } from "react";
import { PUNCTUATION, TriggerFn } from "../type-ahead/type-ahead-plugin";

export function useBasicTypeaheadTriggerMatchV2(
  trigger: string,
  {
    minLength = 1,
    maxLength = 75,
    punctuation = PUNCTUATION,
    allowWhitespace = false,
  }: {
    minLength?: number;
    maxLength?: number;
    punctuation?: string;
    allowWhitespace?: boolean;
  }
): TriggerFn {
  if (trigger.length > 2 || trigger.length === 0) {
    throw new Error(
      "Trigger must be a single character or two characters like"
    );
  }
  return useCallback(
    (text: string) => {
      const prefix = trigger.length === 2 ? `|${trigger[0]}` : "";
      const validCharsSuffix = allowWhitespace ? "" : String.raw`\s`;
      const validChars = "[^" + trigger + punctuation + validCharsSuffix + "]";
      const TypeaheadTriggerRegex = new RegExp(
        String.raw`(^|\s|\()(` +
          `${prefix ? `[${prefix}]` : ""}` +
          "[" +
          trigger +
          "]" +
          "((?:" +
          validChars +
          "){0," +
          maxLength +
          "})" +
          ")$"
      );
      // console.log({ TypeaheadTriggerRegex });
      const match = TypeaheadTriggerRegex.exec(text);
      if (match !== null) {
        const maybeLeadingWhitespace = match[1];
        const matchingString = match[3];
        if (matchingString.length >= minLength) {
          return {
            leadOffset: match.index + maybeLeadingWhitespace.length,
            matchingString,
            replaceableString: match[2],
          };
        }
      }
      return null;
    },
    [allowWhitespace, trigger, punctuation, maxLength, minLength]
  );
}
